import { render, staticRenderFns } from "./EventHead.vue?vue&type=template&id=1c84cac5&scoped=true"
import script from "./EventHead.vue?vue&type=script&lang=js"
export * from "./EventHead.vue?vue&type=script&lang=js"
import style0 from "./EventHead.vue?vue&type=style&index=0&id=1c84cac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84cac5",
  null
  
)

export default component.exports